export default "__VITE_ASSET__BqXjUSFe__"